import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ManageComponent } from './manage.component';
import { AuthGuard } from '@guards/auth/auth.guard';
import { RoleGuard } from '@guards/role/role.guard';

import { RfidCardsTableComponent } from '@components/entities/rfid-cards/rfid-cards-table/rfid-cards-table.component';
import { UnassignedRfidCardsTableComponent } from '@components/entities/rfid-cards/unassigned-rfid-cards-table/unassigned-rfid-cards-table.component';
import { CreateUserDialogComponent } from '@components/dialog/create-user-dialog/create-user-dialog.component';
import { DeleteUserDialogComponent } from '@components/dialog/delete-user-dialog/delete-user-dialog.component';
import { EditUserDialogComponent } from '@components/dialog/edit-user-dialog/edit-user-dialog.component';
import { UsersTableComponent } from '@components/entities/users/users-table/users-table.component';
import { ProfileComponent } from './profile/profile.component';
import { CreateRfidCardDialogComponent } from '@components/dialog/create-rfid-card-dialog/create-rfid-card-dialog.component';
import { EditRfidCardDialogComponent } from '@components/dialog/edit-rfid-card-dialog/edit-rfid-card-dialog.component';
import { EditEmailDialogComponent } from '@components/dialog/edit-email-dialog/edit-email-dialog.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'manage', component: ManageComponent, canActivate: [AuthGuard, RoleGuard], data: { roles: ['Customer'] }, children: [
            {
              path: '',
              redirectTo: 'users',
              pathMatch: 'full'
            },
            {
              path: 'users',
              component: UsersTableComponent,
              children: [
                {
                  path: 'create',
                  component: CreateUserDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: EditUserDialogComponent
                },
                {
                  path: 'delete/:key',
                  component: DeleteUserDialogComponent
                }
              ]
            },
            {
              path: 'rfid',
              component: RfidCardsTableComponent,
              children: [
                {
                  path: 'create',
                  component: CreateRfidCardDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: EditRfidCardDialogComponent
                }
              ]
            },
            {
              path: 'unassigned-rfid',
              component: UnassignedRfidCardsTableComponent,
              children: [
                {
                  path: 'create',
                  component: CreateRfidCardDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: EditRfidCardDialogComponent
                }
              ]
            },
            {
              path: 'profile',
              component: ProfileComponent,
              children: [
                {
                  path: 'email',
                  component: EditEmailDialogComponent
                }
              ]
            },
          ]
        },
      ]
    )
  ],
  providers: [
  ],
})
export class ManageModule { }
